"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    children: _propTypes.default.any,
    href: _propTypes.default.string,
    type: _propTypes.default.oneOf(Object.keys(_constant2.REDIRECTION_TYPE)),
    target: _propTypes.default.oneOf(Object.keys(_constant2.LINK_TARGET)),
    size: _propTypes.default.oneOf(_constant.ARR_FONT_SIZE),
    width: _propTypes.default.string,
    margin: _propTypes.default.arrayOf(_constant.ARR_SPACING_TYPES),
    underlined: _propTypes.default.bool,
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    buttonType: _propTypes.default.string,
    color: _propTypes.default.oneOf(_constant.ARR_COLORS),
    hoverColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    backgroundColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    hoverBackgroundColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    queryParams: _propTypes.default.object,
    handleClick: _propTypes.default.func,
    cardIndex: _propTypes.default.number,
    boxShadow: _propTypes.default.bool,
    disabled: _propTypes.default.bool,
    border: _propTypes.default.oneOf(_constant.ARR_COLORS),
    defaultDisabledFeatures: _propTypes.default.bool,
    updateGtmId: _propTypes.default.func,
    buttonName: _propTypes.default.string,
    paddingLeft: _propTypes.default.arrayOf(_constant.ARR_SPACING_TYPES),
    paddingRight: _propTypes.default.arrayOf(_constant.ARR_SPACING_TYPES),
    fontWeight: _propTypes.default.arrayOf(_constant.ARR_FONT_WEIGHT),
    borderRadius: _propTypes.default.number
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    target: _constant2.LINK_TARGET.tab.type,
    color: 'primary',
    size: _constant.DEFAULT_FONT_SIZE,
    type: _constant2.REDIRECTION_TYPE.normal,
    cardIndex: 0,
    boxShadow: true,
    disabled: false,
    defaultDisabledFeatures: true,
    fontWeight: _constant.ARR_FONT_WEIGHT[0]
  }
};
exports.default = _default;